import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { BoxscoreModel } from 'src/app/models/Boxscore';
import { PlaybyplayModel } from 'src/app/models/Playbyplay';
import { PlayerModel } from 'src/app/models/Player';
import { GameService } from 'src/app/services/game.service';

@Component({
  selector: 'app-boxscore',
  templateUrl: './boxscore.component.html',
  styleUrls: ['./boxscore.component.css']
})
export class BoxscoreComponent implements AfterViewInit, OnDestroy {

  private boxscoreRefresh:any = null;
  @Input() gameId:string = ''; 
  @Input() src:string = ''; 
  public firstTab:string = 'boxscore';
  public secondTab:number = 1;
  public boxscore: BoxscoreModel = new BoxscoreModel();
  public get boxscoreLineup():PlayerModel[]{
      return this.secondTab == 1 ? this.boxscore.awayLineup : this.boxscore.homeLineup;
  };
  public get boxscorePitchers():PlayerModel[]{
      return this.secondTab == 1 ? this.boxscore.awayPitchers : this.boxscore.homePitchers;
  };
  public get playbyplays(): PlaybyplayModel[]{
      const plays: PlaybyplayModel[] = [];
      for(let p of this.boxscore.playbyplays){
          const nP = new PlaybyplayModel();
          nP.inning = p.inning
          nP.top = this.secondTab == 1 ? p.top : p.bottom;
          if(nP.top.length > 0){
              plays.push(nP);
          }
      }
      return plays;
  };
  constructor(private gameService: GameService) { }

  ngOnDestroy(): void {
    if(this.boxscoreRefresh !== null){
      clearInterval(this.boxscoreRefresh);
    }
  }

  ngAfterViewInit(): void {
    if(this.gameId !== ''){
      this.getBoxscore();
      this.boxscoreRefresh = setInterval(() => {
          this.getBoxscore();
      },15000);
    }
  }

  private getBoxscore(){
    this.gameService.getGameById(this.gameId).subscribe({
        next:(boxscore) => {
            this.gameService.getGamePlaybyPlayById(this.gameId).subscribe({
                next:(playbyplay) => {
                    boxscore.playbyplays = playbyplay.reverse();
                    this.boxscore = boxscore;
                }, error:()=> {
                    this.boxscore = boxscore;
                    this.boxscore.playbyplays = [];
                }
            });
        },
        error:(err) => { }
    });
  }

}
